var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.parts),function(part,index){return _c('span',{key:("part-" + index),class:{ 'phrase-with-user-text__user-text': part.isUserText }},[_vm._v(_vm._s(part.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }